export const settings = {
  setShareTitle: '앱 공유',
  setNotifiationsTitle: '알림',
  setContactAppOwnerTitle: '앱 소유자에게 연락하기',
  setContactDevelopersTitle: '개발자에게 연락하기',
  setReportAppTitle: '앱 신고',
  setDeleteAccountTitle: '계정 삭제',
  setLogOutTitle: '로그아웃',
  setShareAppCurtainTitle: '앱 공유',
  setShareAppCurtainButtonTitle: '링크 복사',
  setShareAppAlertWhenAppLinkWasCopied: '링크가 복사되었습니다!',
  setNotificationsInAppTitle: '앱 내',
  setNotificationsPushContent: '푸시',
  setNotificationsChatsTitle: '채팅',
  setNotificationsDiscussionsTitle: '토론',
  setNotificationsNewsTitle: '뉴스 피드',
  setNotificationsEventsTitle: '이벤트',
  setNotificationsAdminTitle: '관리자 메시지',
  setNotificationsBlogTitle: '블로그',
  setNotificationsPushOffContent: '푸시 알림이 꺼져 있습니다',
  setNotificationsPushOffText: '푸시를 활성화하려면 디바이스 설정으로 이동하여 알림을 허용하십시오',
  setReportAppFlagCurtainTitle: '신고',
  setAppReportedCurtainContent: '컨텐츠가 신고되었습니다',
  setDeleteCurtainTitle: '계정 삭제',
  setDeleteCurtainInputContent: '비밀번호',
  setDeleteCurtainCancelButtonTitle: '취소',
  setDeleteCurtainConfirmButtonTitle: '확인',
  setDeleteCurtainIncorrectPasswordAlertText: '비밀번호가 잘못되었습니다',
  setTurnNotificationsOnText: '푸시 알림을 활성화하려면 아래 버튼을 클릭하여 알림 수신을 허용하십시오.',
  setTurnNotificationsOnButton: '푸시 알림 켜기',
  changeLanguage: '앱 언어 변경',
  changeLanguageAlertSuccess: '앱 언어가 성공적으로 변경되었습니다'
}
